"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAllValue = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const react_hook_form_1 = require("react-hook-form");
const react_select_1 = __importDefault(require("react-select"));
const clsx_1 = __importDefault(require("clsx"));
const FieldErrorSectionForm_1 = __importDefault(require("@App/kit/fields/FieldErrorSectionForm"));
exports.selectAllValue = 'Select all';
const MultiDropdownForm = (props) => {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { name, options, mainColor = true, label, assistiveText, placeholder, className, assistiveTextFunction, showLabelOnSelect = true, registerOptions, isPhoneType = false, defaultValue, assistiveTextVisibility, isClearable, } = props;
    const required = !!registerOptions && !!registerOptions.required;
    const displayAssistiveText = assistiveText !== null && assistiveText !== void 0 ? assistiveText : (assistiveTextFunction ? assistiveTextFunction(required) : undefined);
    const theDefaultValue = defaultValue ? defaultValue : '';
    const getSelectedValue = (value) => {
        if (value.some((val) => val === exports.selectAllValue)) {
            return options.filter((opt) => opt.value !== exports.selectAllValue);
        }
        else {
            return options.filter((opt) => value.some((val) => val === opt.value));
        }
    };
    return (react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, defaultValue: theDefaultValue, rules: registerOptions, render: ({ field: { value, onChange, onBlur, ref }, fieldState }) => {
            const outerDivClassNames = (0, clsx_1.default)('dropdown-multi-form-component', mainColor ? 'main-color-set' : 'second-color-set', className, !!fieldState.error && 'error', isPhoneType && 'phone-code-form-type');
            const selectedValue = getSelectedValue(value);
            const onChangeWrapper = (newValues, actionMeta) => {
                const valueArray = newValues.map((newValue) => newValue.value);
                onChange(valueArray);
            };
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: outerDivClassNames },
                    !!value && !!label && showLabelOnSelect && (react_1.default.createElement("label", { className: "dropdown-multi-form-label", htmlFor: name }, label)),
                    react_1.default.createElement("div", { className: "select-multi-form-component" },
                        react_1.default.createElement(react_select_1.default, { inputId: name, name: name, key: `select-${name}-${value}`, ref: ref, options: options, placeholder: placeholder ? placeholder : label, value: selectedValue, onBlur: onBlur, onChange: onChangeWrapper, classNamePrefix: "react-multi-select", isClearable: !!isClearable, isMulti: true })),
                    react_1.default.createElement(FieldErrorSectionForm_1.default, { name: name, assistiveText: displayAssistiveText, visibility: assistiveTextVisibility, required: required }))));
        } }));
};
exports.default = MultiDropdownForm;
